var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMasterCard = function SvgMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    fill: "#F8F8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.245 7.168h-6.49v11.663h6.49V7.168Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 13A7.404 7.404 0 0 1 17 7.169a7.417 7.417 0 1 0 0 11.662A7.402 7.402 0 0 1 14.167 13Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13a7.416 7.416 0 0 1-12 5.831A7.417 7.417 0 0 0 17 7.17 7.416 7.416 0 0 1 29 13ZM28.293 17.596v-.239h.096v-.049h-.245v.049h.096v.239h.053Zm.476 0v-.288h-.076l-.086.198-.087-.198h-.075v.288h.053v-.217l.081.187h.055l.081-.188v.218h.053Z",
    fill: "#F79E1B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    stroke: "#7F939D"
  })));
};
export default SvgMasterCard;